module.exports = __webpack_public_path__ + "static/IBC-og-image-36afa1381bfc456b58c55b0b96ab853d.jpg";